<template>
    <div>
        <b-card no-body class="page-card">
            <b-card-header class="mx-3 px-0">
                <i class="fa fa-align-justify"></i> {{ trans.title }}
            </b-card-header>
            <b-card-body class="p-0">

                <div class="loading-box" v-if="loading">
                    <div class="loading-inner"><i class="fa fa-spin fa-circle-notch text-secondary"></i></div>
                </div>

                <div class="news-state" v-if='!loading && isUnavailable'>
                    <span class="news-state-icon"><i class="fal fa-newspaper"></i></span>
                    <p class="news-state-text">{{ trans.errorUnavailable }}</p>
                    <b-button variant="primary" size="sm" class="news-state-btn" @click="loadData">
                        <i class="fa fa-redo mr-1"></i> {{ trans.btnRetry }}
                    </b-button>
                </div>

                <div class="news-state" v-if='!loading && !isUnavailable && isEmptyItemsList'>
                    <span class="news-state-icon"><i class="fal fa-newspaper"></i></span>
                    <p class="news-state-text">{{ trans.empty }}</p>
                </div>

                <b-list-group flush v-if='!loading && !isUnavailable && !isEmptyItemsList'>
                    <b-list-group-item v-for="item in newsItems" v-bind:key="item.id" :class="{'active': isActive(item.id), 'px-3': true}">
                        <div class="list-header" :class="{'mb-0': compactView}">
                            <a :href="'/dashboard/article/'+item.id" class="btn btn-view btn-sm btn-primary"><i class="fa fa-eye"></i></a>
                            <a :href="'/dashboard/article/'+item.id" class="title">
                                <span>{{ item.title }}</span><span style="color:red" v-if="typeof seenNews !== 'undefined' && typeof seenNews[item.id] !== 'undefined' && !seenNews[item.id]"> *</span><br>
                                <small>{{ item.dateFormatted }}</small>
                            </a>
                        </div>

                        <p v-if="!compactView" v-html="item.bodyShort"></p>
                    </b-list-group-item>
                </b-list-group>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: 'news',

        props: {
            'items': {
                type: Array
            },
            'trans': {
                type: Object
            },
            'seenLatestNews': {
                type: Object
            },
            'unavailable': {
                type: Boolean,
                default: function() {
                    return false;
                }
            },
            'compactView': {
                type: Boolean,
                default: function() {
                    return false;
                }
            },
            'lazy': {
                type: Boolean,
                default: function() {
                    return false;
                }
            },
            'limit': {
                type: Number,
                default: function() {
                    return 5;
                }
            },
            activeItem: {
                type: String,
                default: function() {
                    return "0";
                }
            },
        },

        created() {
            if(this.lazy) this.loadData();
        },

        data() {
            return {
                loading: this.lazy,
                newsItems: this.items ? this.items : [],
                seenNews: this.seenLatestNews ? this.seenLatestNews : {},
                isUnavailable: this.unavailable
            };
        },

        computed: {
            isEmptyItemsList() {
                return !this.newsItems || this.newsItems.length === 0;
            }
        },

        methods: {

            isActive(id)
            {
                return this.activeItem === id;
            },

            loadData()
            {
                this.loading = true;
                var _this = this;

                axios.get("/dashboard/news", { params: { limit: this.limit } }).then(function (response) {
                    if(response && response.data)
                    {
                        _this.newsItems = response.data.items ? response.data.items : [];
                        _this.seenNews = response.data.seenLatestNews ? response.data.seenLatestNews : {};
                        _this.isUnavailable = !!response.data.unavailable;
                    }

                    _this.loading = false;
                }, function (error) {
                    _this.isUnavailable = true;
                    _this.loading = false;
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/admin/js/dashboard/widgets/News.vue